// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1g-e";
export var animationRelative = "_1g-d";
export var backdropBlur = "_1g-0";
export var detailLabelCell = "_1g-q";
export var detailTable = "_1g-p";
export var detailValueCell = "_1g-r";
export var documentTypeIcon = "_1g-y";
export var documentTypeOption = "_1g-x";
export var dropdownMatchDatePicker = "_1g-3";
export var evidenceCardContent = "_1g-w";
export var gorgiasTicketCard = "_1g-s";
export var iconTertiary = "_1g-z";
export var integrationCard = "_1g-1";
export var integrationLogoBox = "_1g-2";
export var mainColumnSticky = "_1g-v";
export var maxWidthContainer = "_1g-t";
export var modalContentBody = "_1g-a";
export var modalHeaderImage = "_1g-5";
export var modalImageLabel = "_1g-7";
export var modalImageOverlay = "_1g-6";
export var modalImageSubtitle = "_1g-9";
export var modalImageTitle = "_1g-8";
export var modalImageWrapper = "_1g-4";
export var modalStickyFooter = "_1g-b";
export var sidebarColumn = "_1g-u";
export var timelineLine = "_1g-m";
export var timelineLineBlack = "_1g-o _1g-m";
export var timelineLineGray = "_1g-n _1g-m";
export var timelineLineHeight = "_1g-l";
export var tlDotActivate = "_1g-i";
export var tlDotActivateAnim = "_1g-h";
export var tlDotHide = "_1g-g";
export var tlDotHideAnim = "_1g-f";
export var tlLineActivate = "_1g-k";
export var tlLineActivateAnim = "_1g-j";
export var uploadedFileRow = "_1g-c";